var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-for-user"},[_c('PHeader'),_c('UserProfileCard',{attrs:{"in-profile":true,"username":_vm.filters.userFilter}}),(_vm.profile.token)?_c('Profile',{attrs:{"token":_vm.profile.token}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }